<div class="discount p-0" *ngIf="sharedService.isBrowser()">
  <!--*ngIf="discountData?.title || discountData?.description"-->
  <div class="discount__header" *ngIf="isAdmin || discountData?.title">
    <div class="discount__header__edit" (click)="openEditModal()" *ngIf="isAdmin">
      <i class="fa-solid fa-pencil"></i>
    </div>
    <div class="discount__header__edit" style="top: 2.5rem" (click)="openAddModal()"
      *ngIf="isAdmin && discountData?.id">
      <i class="fa-solid fa-plus"></i>
    </div>

    <div class="discount__header__title" *ngIf="discountData?.title">{{ discountData?.title }}</div>
    <h2 *ngIf="discountData?.title" class="d-none">{{ discountData?.title }}</h2>
    <div #textElement class="discount__header__description" [class.less]="seeMore" *ngIf="discountData?.description">
      {{ discountData?.description }}
    </div>
    <div class="discount__header__see-more" *ngIf="isLongText && discountData?.description"
      (click)="seeMore = !seeMore">
      <span>See {{ seeMore ? "More" : "Less" }}</span>
    </div>
  </div>

  <div class="discount__chevron" *ngIf="discountData?.DiscountLists?.length">
    <!-- <i class="fa-solid fa-chevron-down" [ngClass]="{'rotated': isOpen}" (click)="isOpen = !isOpen"></i> -->
    <span (click)="isOpen = !isOpen">See {{ isOpen ? "Less" : "More" }}</span>
  </div>

  <div class="discount__content">
    <ng-container *ngIf="isOpen">
      <ng-container *ngFor="let item of discountData?.DiscountLists">
        <div class="discount__content__item">
          <div class="discount__content__item__delete" *ngIf="isAdmin" (click)="deleteDiscountItem(item.id)">
            <i class="fa-solid fa-trash"></i>
          </div>
          <div class="discount__content__item__image">
            <div class="discount__content__item__image__badge">
              <div class="discount__content__item__image__badge__discount">{{ item?.discountType != "percentage" ? "$" :
                "" }}{{ item?.discount }}{{ item?.discountType == "percentage" ? "%" : "" }}</div>
              <div class="discount__content__item__image__badge__text">
                {{ item?.discountText }}
              </div>
            </div>
            <img [src]="imageUrl + item?.image" alt="Discount 1" (error)="commonService.handleError($event)" />
          </div>
        </div>
      </ng-container>
    </ng-container>
    <!-- Banner Images Display - Slider -->
    <ng-container *ngIf="discountData?.showBanner && discountData?.bannerImages && discountData.bannerImages.length > 0">
      <div class="discount__content__banner-slider">
        <app-my-carousel-swiper [config]="carouselOptions" [autoplay]="{ delay: 3000 }"
          [navigation]="!isMobile && discountData.bannerImages.length > 1">
          <div class="swiper-slide discount__content__banner"
            *ngFor="let bannerImage of discountData.bannerImages; let i = index">
            <div class="discount__content__banner__delete" *ngIf="isAdmin" (click)="deleteBannerImage(i)">
              <i class="fa-solid fa-trash"></i>
            </div>
            <img [src]="imageUrl + bannerImage" (click)="openBookModal.emit()"
              (error)="commonService.handleError($event)" alt="Discount Banner {{ i + 1 }}"
              class="discount__content__banner__image" />
          </div>
        </app-my-carousel-swiper>
      </div>
    </ng-container>
    <!-- Legacy single banner_image support -->
    <div class="discount__content__banner"
      *ngIf="discountData?.showBanner && discountData?.banner_image && (!discountData?.bannerImages || discountData.bannerImages.length === 0)">
      <div class="discount__content__banner__delete" *ngIf="isAdmin" (click)="deleteBannerImage()">
        <i class="fa-solid fa-trash"></i>
      </div>
      <img [src]="imageUrl + discountData.banner_image" (click)="openBookModal.emit()"
        (error)="commonService.handleError($event)" alt="Discount Banner" class="discount__content__banner__image" />
    </div>
    <!-- Icon Items Display (when showBanner is false) -->
    <div class="discount__content__icons" *ngIf="!discountData?.showBanner && iconItems && iconItems.length > 0">
      <div class="discount__content__icons__container">
        <div class="discount__content__icons__item" *ngFor="let iconItem of iconItems; let i = index">
          <div class="discount__content__icons__item__circle" *ngIf="iconItem.icon || iconItem.iconPreview">
            <img [src]="iconItem.iconPreview || (imageUrl + iconItem.icon)" 
                 [alt]="iconItem.text || 'Icon'" 
                 (error)="commonService.handleError($event)"
                 class="discount__content__icons__item__image" />
          </div>
          <div class="discount__content__icons__item__text" *ngIf="iconItem.text">
            {{ iconItem.text }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Template -->
<ng-template #editModalTemplate let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Edit Nearby Page</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <form>
      <div class="form-group">
        <label for="title" class="form-label">Title</label>
        <input type="text" class="form-control" id="title" [(ngModel)]="discountData.title" name="title"
          placeholder="Enter discount title" />
      </div>

      <div class="form-group">
        <label for="description" class="form-label">Description</label>
        <textarea class="form-control" id="description" [(ngModel)]="discountData.description" name="description"
          rows="3" placeholder="Enter discount description"></textarea>
      </div>

      <div class="form-group">
        <label for="shareWithOtherTitle" class="form-label">Share with Others Title</label>
        <input type="text" class="form-control" id="shareWithOtherTitle" [(ngModel)]="discountData.shareWithOtherTitle"
          name="shareWithOtherTitle" placeholder="Enter title for Share with Others section" />
      </div>

      <div class="form-group">
        <div class="d-flex align-items-center">
          <label class="toggle-switch">
            <input type="checkbox" id="showBanner" [checked]="discountData.showBanner"
              (change)="discountData.showBanner = $event.target.checked" />
            <span class="toggle-switch__slider"></span>
          </label>
          <label for="showBanner" class="toggle-switch__label ml-2">Show Banner</label>
        </div>
      </div>

      <div class="form-group">
        <div class="d-flex align-items-center">
          <label class="toggle-switch">
            <input type="checkbox" id="showBiggerBanner" [checked]="discountData.showBiggerBanner"
              (change)="discountData.showBiggerBanner = $event.target.checked" />
            <span class="toggle-switch__slider"></span>
          </label>
          <label for="showBiggerBanner" class="toggle-switch__label ml-2">Show Bigger Banner</label>
        </div>
      </div>

      <!-- Banner Images (shown when showBanner is true) -->
      <div class="form-group" *ngIf="discountData.showBanner">
        <label for="bannerImage" class="form-label">Banner Images</label>

        <!-- Custom styled file upload button -->
        <div class="file-upload-container">
          <input type="file" class="file-input-hidden" id="bannerImage" (change)="onBannerImageSelected($event)"
            accept="image/*" multiple #fileInput />
          <label for="bannerImage" class="file-upload-label">
            <i class="fa-solid fa-cloud-arrow-up"></i>
            <span>Choose Images (Multiple allowed)</span>
            <small class="text-muted">Click to select or drag and drop</small>
          </label>
        </div>

        <!-- Existing banner images with edit/delete options -->
        <div class="existing-banner-images mt-3" *ngIf="existingBannerImages.length > 0">
          <label class="form-label text-muted mb-2">Existing Banner Images:</label>
          <div class="preview-grid">
            <div class="banner-image-preview-item" *ngFor="let existingImage of existingBannerImages; let i = index"
              [class.deleted]="existingImage.isDeleted">
              <img [src]="existingImage.url" class="img-fluid banner-preview-image" alt="Existing Banner {{ i + 1 }}"
                [class.image-deleted]="existingImage.isDeleted" />
              <div class="banner-preview-overlay" *ngIf="!existingImage.isDeleted && !existingImage.isReplaced">
                <div class="overlay-buttons">
                  <button type="button" class="btn btn-sm btn-danger" (click)="deleteExistingBannerImage(i)"
                    title="Delete">
                    <i class="fa-solid fa-trash"></i>
                  </button>
                  <label class="btn btn-sm btn-primary" title="Replace">
                    <i class="fa-solid fa-pencil"></i>
                    <input type="file" class="file-input-hidden" accept="image/*" [id]="'replace-image-' + i"
                      (change)="replaceExistingBannerImage(i, $event)" style="display: none" />
                  </label>
                </div>
              </div>
              <div class="banner-preview-overlay replaced-overlay"
                *ngIf="existingImage.isReplaced && !existingImage.isDeleted">
                <div class="overlay-buttons">
                  <span class="badge bg-info mb-2">Replaced</span>
                  <button type="button" class="btn btn-sm btn-danger" (click)="deleteExistingBannerImage(i)"
                    title="Delete">
                    <i class="fa-solid fa-trash"></i>
                  </button>
                  <button type="button" class="btn btn-sm btn-success" (click)="restoreExistingBannerImage(i)"
                    title="Restore Original"><i class="fa-solid fa-undo"></i> Restore</button>
                </div>
              </div>
              <div class="banner-preview-overlay deleted-overlay" *ngIf="existingImage.isDeleted">
                <div class="overlay-buttons">
                  <span class="badge bg-danger mb-2">Marked for deletion</span>
                  <button type="button" class="btn btn-sm btn-success" (click)="restoreExistingBannerImage(i)"
                    title="Restore"><i class="fa-solid fa-undo"></i> Restore</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Preview container for newly added images -->
        <div class="banner-images-preview mt-3" *ngIf="bannerImagePreviews.length > 0">
          <label class="form-label text-muted mb-2" *ngIf="existingBannerImages.length > 0">New Images to
            Upload:</label>
          <div class="preview-grid">
            <div class="banner-image-preview-item" *ngFor="let preview of bannerImagePreviews; let i = index">
              <img [src]="preview.url" class="img-fluid banner-preview-image" alt="Banner Preview {{ i + 1 }}" />
              <div class="banner-preview-overlay">
                <button type="button" class="btn btn-sm btn-danger" (click)="removeBannerImage(i)">
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Icon Items (shown when showBanner is false) -->
      <div class="form-group" *ngIf="!discountData.showBanner">
        <label class="form-label mb-3">
          <i class="fa-solid fa-icons"></i> Icon Items
        </label>

        <div class="icon-items-list">
          <div class="icon-item-card" *ngFor="let item of iconItems; let i = index" [class.deleted]="item.isDeleted">
            <div class="icon-item-header">
              <span class="icon-item-number">#{{ i + 1 }}</span>
              <button type="button" class="icon-action-btn icon-delete" 
                *ngIf="!item.isDeleted" (click)="removeIconItem(i)" title="Delete">
                <i class="fa-solid fa-trash"></i>
              </button>
            </div>

            <div class="icon-item-body">
              <!-- Row 1: File Upload | Preview -->
              <div class="icon-upload-preview-row">
                <div class="icon-upload-area">
                  <input type="file" class="icon-file-input" accept="image/*" 
                    [id]="'iconFile_' + i" (change)="onIconFileSelected(i, $event)" />
                  <label [for]="'iconFile_' + i" class="icon-upload-label">
                    <i class="fa-solid fa-cloud-arrow-up"></i>
                    <span class="upload-text">{{ item.iconPreview ? 'Replace' : 'Upload' }}</span>
                  </label>
                </div>
                <div class="icon-preview-container" *ngIf="item.iconPreview">
                  <img [src]="item.iconPreview" alt="Icon Preview" class="icon-preview-image" />
                </div>
              </div>

              <!-- Row 2: Label Text -->
              <div class="icon-text-section">
                <label class="icon-text-label" [for]="'iconText_' + i">
                  <i class="fa-solid fa-font"></i> Label Text
                </label>
                <input type="text" class="icon-text-input" 
                  [id]="'iconText_' + i" [(ngModel)]="item.text" [name]="'iconText_' + i" 
                  placeholder="Enter label text for this icon..." 
                  *ngIf="!item.isDeleted" />
                <div class="icon-text-disabled" *ngIf="item.isDeleted">
                  <i class="fa-solid fa-lock"></i> Item marked for deletion
                </div>
              </div>
            </div>
          </div>
        </div>

        <button type="button" class="icon-add-btn" (click)="addIconItem()">
          <i class="fa-solid fa-plus-circle"></i>
          <span>Add New Icon Item</span>
        </button>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="saveChanges()" [disabled]="isLoading">Save Changes</button>
  </div>
</ng-template>
<ng-template #uploadModalTemplate let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Upload Discount</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <form>
      <div class="form-group">
        <label for="text" class="form-label">Discount Text</label>
        <input type="text" class="form-control" id="text" [(ngModel)]="uploadData.discountText" name="text"
          placeholder="Enter discount text" />
      </div>

      <div class="form-group">
        <label for="price" class="form-label">Discount Amount</label>
        <input type="number" class="form-control" id="price" [(ngModel)]="uploadData.amount" name="price"
          placeholder="Enter discount amount" />
      </div>

      <div class="form-group">
        <label for="priceType" class="form-label">Discount Type</label>
        <select class="form-control" id="priceType" [(ngModel)]="uploadData.discountType" name="priceType">
          <option value="percentage">Percentage (%)</option>
          <option value="fixed">Fixed Amount</option>
        </select>
      </div>

      <div class="form-group">
        <label for="image" class="form-label">Image</label>
        <input type="file" class="form-control" id="image" (change)="onImageSelected($event)" accept="image/*" />

        <div class="image-preview mt-2" *ngIf="imagePreview">
          <img [src]="imagePreview" class="img-fluid" style="max-height: 200px; border-radius: 8px" />
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="saveUpload()" [disabled]="isLoading">Save Changes</button>
  </div>
</ng-template>